export enum DriverType {
  UNKNOWN = 0,
  REGULAR = 1,
  LONG_DISTANCE = 2,
  BROOM_CAR = 4,
  MOBILE_WASHER = 8,
  IMPLANT_WASHER = 16,
  IMPLANT_OFFICE = 32,
  MOBILE_WORKSHOP = 64,
  DISPATCH_CAR = 128,
}

export const DriverTypeLabel: Record<DriverType, string> = {
  [DriverType.UNKNOWN]: 'driver_type.unknown',
  [DriverType.REGULAR]: 'driver_type.regular',
  [DriverType.LONG_DISTANCE]: 'driver_type.long_distance',
  [DriverType.BROOM_CAR]: 'driver_type.broom_car',
  [DriverType.MOBILE_WASHER]: 'driver_type.mobile_washer',
  [DriverType.IMPLANT_WASHER]: 'driver_type.implant_washer',
  [DriverType.IMPLANT_OFFICE]: 'driver_type.implant_office',
  [DriverType.MOBILE_WORKSHOP]: 'driver_type.mobile_workshop',
  [DriverType.DISPATCH_CAR]: 'driver_type.dispatch_car',
};

export enum DriverTypeApiValue {
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  REGULAR = 'REGULAR',
  LONG_DISTANCE = 'LONG_DISTANCE',
  BROOM_CAR = 'BROOM_CAR',
  MOBILE_WASHER = 'MOBILE_WASHER',
  IMPLANT_WASHER = 'IMPLANT_WASHER',
  IMPLANT_OFFICE = 'IMPLANT_OFFICE',
  MOBILE_WORKSHOP = 'MOBILE_WORKSHOP',
  DISPATCH_CAR = 'DISPATCH_CAR',
}

export const DriverTypeApiLabel: Record<DriverTypeApiValue, string> = {
  [DriverTypeApiValue.NOT_SPECIFIED]: 'driver_type.unknown',
  [DriverTypeApiValue.REGULAR]: 'driver_type.regular',
  [DriverTypeApiValue.LONG_DISTANCE]: 'driver_type.long_distance',
  [DriverTypeApiValue.BROOM_CAR]: 'driver_type.broom_car',
  [DriverTypeApiValue.MOBILE_WASHER]: 'driver_type.mobile_washer',
  [DriverTypeApiValue.IMPLANT_WASHER]: 'driver_type.implant_washer',
  [DriverTypeApiValue.IMPLANT_OFFICE]: 'driver_type.implant_office',
  [DriverTypeApiValue.MOBILE_WORKSHOP]: 'driver_type.mobile_workshop',
  [DriverTypeApiValue.DISPATCH_CAR]: 'driver_type.dispatch_car',
};
